const AchievementData=[
    { 
        text:"Participated in Battle Brains organized by BIT-D and secured 3rd prize.",
        source:"https://scontent.fpat2-1.fna.fbcdn.net/v/t39.30808-6/326194772_944474693384675_6163937164967789004_n.png?_nc_cat=102&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=rrgBL4K03C0AX8QHdFA&_nc_ht=scontent.fpat2-1.fna&oh=00_AfCHsaTPOocMlxVsv1fEVLqZAwHuPzZh02hJPXsBb9KZuQ&oe=64B025AD",
        effct: "fade-left",
        code: "https://media.licdn.com/dms/image/C5622AQExAEYKMavoxw/feedshare-shrink_800/0/1656533591510?e=1691625600&v=beta&t=1MOIqH58Zm8cDdc4F56LkslxkWjG78kNeKhrtkJwOvY",
        link: "https://media.licdn.com/dms/image/C5622AQExAEYKMavoxw/feedshare-shrink_800/0/1656533591510?e=1691625600&v=beta&t=1MOIqH58Zm8cDdc4F56LkslxkWjG78kNeKhrtkJwOvY",
    }    ,
    {
        text:"Won 3rd Prize in Nirman Web_Dev hackathon held at college level.",
        source: "https://i.ibb.co/BKF7RRf/birla-institute-of-technology-mesra-logo-1-fotor-2023071132748.jpg",
        effct: "fade-right",
        code: "https://media.licdn.com/dms/image/C4D22AQHpkWH0Y-L91A/feedshare-shrink_1280/0/1630834858771?e=1691625600&v=beta&t=hPFqcSKNRIFqKcLPeGiAwLW7FEAzSyQe0DhiaA-ciZA" ,
        link: "https://media.licdn.com/dms/image/C4D22AQHpkWH0Y-L91A/feedshare-shrink_1280/0/1630834858771?e=1691625600&v=beta&t=hPFqcSKNRIFqKcLPeGiAwLW7FEAzSyQe0DhiaA-ciZA" 
    },
    { 
        text:"Secured 3rd Position in Coding Contest organized by GFG-BTI.",
        source:"https://media.licdn.com/dms/image/C560BAQFPf0CD9-_Rlg/company-logo_200_200/0/1625297672025?e=2147483647&v=beta&t=YW8ZNowsXYkvKuw0Yse2urJt30juaYlJ8hEpul_BOQc",
        effct: "fade-left",
        code: "https://i.ibb.co/kXrX6vQ/0003.jpg",
        link: "https://drive.google.com/file/d/1CSTohnH2cgnuriiiT4Gr1Zdw5DkWBiiy/view?usp=sharing",
       
    }, 
    {
        link:"https://www.hackerrank.com/8211amanverma",
        text:"Achieved 6 Stars In Problem Solving & 5 Stars in C++ @Hackerrank.",
        source: "https://upload.wikimedia.org/wikipedia/commons/4/40/HackerRank_Icon-1000px.png",
        effct: "fade-right",
        code: "https://i.ibb.co/2hBmg7J/Screenshot-2022-03-05-134400.png",
    },


];

export default AchievementData;